export const GenerateKey = () => {
  const key = new Date().getTime() + Math.random().toString();
  return key;
};
